import { render, staticRenderFns } from "./AccordionAdmin.vue?vue&type=template&id=6bfd63e7&"
import script from "./AccordionAdmin.vue?vue&type=script&lang=js&"
export * from "./AccordionAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports